import React from 'react'
import LinkIcon from '@mui/icons-material/Link'
import type { SxProps, Theme } from '@mui/material'
import { GoogleDriveIcon, GoogleSheetsIcon } from '../components/SystemIcons'
import type { ResourceType } from '../types/resources'

interface ResourceIconProps {
  sx?: SxProps<Theme>
  size?: number
}

const GenericLinkIcon: React.FC<ResourceIconProps> = ({ sx, size = 22 }) =>
  React.createElement(LinkIcon, {
    sx: { color: '#5f6368', fontSize: size, ...sx },
  })

const ICONS: Record<ResourceType, React.ComponentType<ResourceIconProps>> = {
  google_sheet: GoogleSheetsIcon,
  gdrive_folder: GoogleDriveIcon,
  url: GenericLinkIcon,
}

const LABELS: Record<ResourceType, string> = {
  google_sheet: 'Sheet',
  gdrive_folder: 'Drive',
  url: 'URL',
}

export function getResourceIcon(
  resourceType: ResourceType,
): React.ComponentType<ResourceIconProps> {
  return ICONS[resourceType] ?? GoogleSheetsIcon
}

export function getResourceShortLabel(resourceType: ResourceType): string {
  return LABELS[resourceType] ?? resourceType
}

// Admin-surface display order: Google Sheet links first, generic URLs in the
// middle, Google Drive folders last. Used by the FP list "External Links"
// menu and the FP edit-page resources table so the two stay in lockstep.
const TYPE_SORT_ORDER: Record<ResourceType, number> = {
  google_sheet: 0,
  url: 1,
  gdrive_folder: 2,
}

export function resourceTypeSortKey(resourceType: ResourceType): number {
  return TYPE_SORT_ORDER[resourceType] ?? 99
}
